class WHowto extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.viewport = this.querySelector('.w-howto__viewport');
    this.track = this.querySelector('.w-howto__track');
    this.dots = Array.from(this.querySelectorAll('.w-howto__dot'));
    this.cards = this.track ? Array.from(this.track.children) : [];
    this.count = this.cards.length;
    if (!this.viewport || !this.track || this.count <= 1) return;

    const { signal } = this.controller;
    this.mq = window.matchMedia('(max-width: 989px)');
    this.index = 0;
    this.animating = false;

    this.prevButton = this.querySelector('[data-direction="prev"]');
    this.nextButton = this.querySelector('[data-direction="next"]');
    this.prevButton?.addEventListener('click', () => this.move(-1), { signal });
    this.nextButton?.addEventListener('click', () => this.move(1), { signal });
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.select(i), { signal }));
    this.track.addEventListener('transitionend', (event) => this.onTransitionEnd(event), { signal });
    this.viewportWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth === this.viewportWidth) return;
      this.viewportWidth = window.innerWidth;
      this.refresh();
    }, { signal });

    let startX = null;
    this.viewport.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true, signal });
    this.viewport.addEventListener('touchend', (event) => {
      if (startX === null) return;
      const delta = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(delta) > 40) this.move(delta < 0 ? 1 : -1);
    }, { passive: true, signal });

    this.refresh();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  step() {
    return this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
  }

  visibleCount() {
    return Math.max(1, Math.floor((this.viewport.clientWidth + 2) / this.step()));
  }

  maxIndex() {
    return Math.max(0, this.count - this.visibleCount());
  }

  setPosition(animate) {
    this.track.style.transition = animate ? '' : 'none';
    this.track.style.transform = 'translateX(' + -this.index * this.step() + 'px)';
    if (!animate) {
      void this.track.offsetWidth;
      this.track.style.transition = '';
    }
  }

  updateUI() {
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    if (this.prevButton) this.prevButton.disabled = this.index <= 0;
    if (this.nextButton) this.nextButton.disabled = this.index >= this.maxIndex();
  }

  refresh() {
    this.animating = false;
    if (this.animTimer) clearTimeout(this.animTimer);
    if (!this.mq.matches) {
      this.index = 0;
      this.track.style.transition = 'none';
      this.track.style.transform = '';
      void this.track.offsetWidth;
      this.track.style.transition = '';
      this.updateUI();
      return;
    }
    this.index = Math.min(this.index, this.maxIndex());
    this.setPosition(false);
    this.updateUI();
  }

  move(direction) {
    if (!this.mq.matches) return;
    this.animateTo(Math.max(0, Math.min(this.index + direction, this.maxIndex())));
  }

  select(index) {
    if (!this.mq.matches) return;
    this.animateTo(Math.max(0, Math.min(index, this.maxIndex())));
  }

  animateTo(index) {
    if (this.animating || index === this.index) return;
    this.animating = true;
    this.index = index;
    this.setPosition(true);
    this.updateUI();
    if (this.animTimer) clearTimeout(this.animTimer);
    this.animTimer = setTimeout(() => { this.animating = false; }, 500);
  }

  onTransitionEnd(event) {
    if (event.target !== this.track || event.propertyName !== 'transform') return;
    this.animating = false;
  }
}

customElements.define('w-howto', WHowto);
